import gql from 'graphql-tag';

export const Good360EvidencePatchMutation = gql`
	mutation Good360EvidencePatchMutation(
		$id: ID!
		$changes: Good360EvidencePatchInput!
	) {
		results: good360EvidencePatch(id: $id, changes: $changes) {
			id
			type
			startDate
			endDate
		}
	}
`;
